import React from "react";

/** Stacked mini success/failure/retrying bar used inside the health table. */
export default function StatBar({ success, failure, retrying }) {
  const total = success + failure + retrying;
  if (!total) return <div className="h-1.5 bg-zinc-200" data-testid="bar-empty" />;
  const pct = (n) => `${(n / total) * 100}%`;
  return (
    <div className="h-1.5 flex overflow-hidden bg-zinc-200">
      <div className="bg-emerald-600" style={{ width: pct(success) }} />
      <div className="bg-red-600" style={{ width: pct(failure) }} />
      <div className="bg-yellow-500" style={{ width: pct(retrying) }} />
    </div>
  );
}
